import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useUserRoles } from 'src/features/auth/useUserRoles';

import { DefaultRouteLayout } from '../dispatch';

export function ReportsLayout() {
  const navigate = useNavigate();
  const { isBambi, isAdmin, isOwner } = useUserRoles();

  useEffect(() => {
    if (isBambi) {
      return;
    }

    if (!(isAdmin || isOwner)) {
      navigate('/');
    }
  }, [navigate, isBambi, isAdmin, isOwner]);

  return <DefaultRouteLayout />;
}
